import styled from 'styled-components';

export const Clock = styled.div`
	color: ${props => props.theme.typography.primary};
	font-size: calc(0.85rem + ${props => props.theme.fontScale}%);
	margin: auto 0;
`;
